/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BootstrapThemeColorFromJSON, BootstrapThemeColorToJSON, } from './BootstrapThemeColor';
/**
 * Check if a given object implements the GroupInfo interface.
 */
export function instanceOfGroupInfo(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function GroupInfoFromJSON(json) {
    return GroupInfoFromJSONTyped(json, false);
}
export function GroupInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'color': json['color'] == null ? undefined : BootstrapThemeColorFromJSON(json['color']),
    };
}
export function GroupInfoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'color': BootstrapThemeColorToJSON(value['color']),
    };
}
